import React from 'react';
import { Layout } from './components/Layout';
import { Dashboard } from './components/Dashboard';
export function App() {
  return <Layout data-id="element-0">
      <Dashboard data-id="element-1" />
    </Layout>;
}